import { isEmpty, isNil, toNumber, truncate } from 'lodash'
import parserUtils from './utils'

const helpers = {
    buildRoutes: () => {
        const route = '/audience_admin/accounts_dsps.json'
        const params = {
            params: {
                list_limit: 0
            }
        }
        return { route, params }
    },

    parseData: (data, dsps) => {
        const _data = []
        for (const val of data) {
            const partnerKey = parserUtils.getDspParentKey('dsp_' + val.dsp_id, dsps)
            if (!isNil(partnerKey)) {
                const partnerLabel = parserUtils.getDspParentName('dsp_' + val.dsp_id, dsps)
                const cutLabel = isEmpty(val.label) ? truncate(partnerLabel, { length: 30 }) : truncate(val.label, { length: 30 })
                const cutDspClientId = truncate(val.dsp_client_id, { length: 30 })
                const wamData = {
                    ...val,
                    //label: cutLabel + ' - ' + cutDspClientId,
                    transferLabel: cutLabel + ' - ' + cutDspClientId,
                    isSelectable: true,
                    hasChild: false,
                    parentJsonKeyName: 'dsp_' + val.dsp_id,
                    partnerKey,
                    partnerLabel,
                    jsonKey: { ids: [toNumber(val.id)], name: val.label + '_' + val.id, type: 'accountsDsps', subType: null }
                }
                _data.push(wamData)
            }
        }
        return _data
    }
}

export default helpers
